import React from 'react';
import { useState } from 'react';
import { Shield, Calculator, FileSearch, Clock, TrendingUp, AlertTriangle, BrainCircuit, MessageCircle, Play, CheckCircle, Zap, FileText, Users } from 'lucide-react';

const Hero = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('beta-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-32 pb-20 relative overflow-hidden" id="inicio">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/5 to-indigo-900/5 z-0"></div>
      
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full font-medium text-sm">
              🚀 Beta Aberto (Gratuito) — vagas limitadas
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-slate-900">
              ImóvelIA para <span className="text-blue-700">Correspondentes</span>
            </h1>
            
            <p className="text-xl text-slate-700">
              Leitura de editais e matrículas + viabilidade em minutos. Economize horas, reduza risco e feche mais negócios.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToForm}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-medium transition-colors text-lg shadow-lg shadow-blue-600/20 text-center flex items-center justify-center gap-2"
              >
                <Users className="h-5 w-5" />
                Entrar no Beta (gratuito)
              </button>
              <a
                href="https://wa.me/5516999631188?text=Quero%20iniciar%20o%20Beta%20do%20ImóvelIA&utm_source=grupoCB&utm_medium=whatsapp&utm_campaign=beta_aberto"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] hover:bg-[#128C7E] text-white px-8 py-4 rounded-lg font-medium transition-colors text-lg text-center flex items-center justify-center gap-2 shadow-lg shadow-green-600/20"
              >
                <MessageCircle className="h-5 w-5" />
                Falar no WhatsApp
              </a>
            </div>

            {/* Trust Bar */}
            <div className="bg-white/80 backdrop-blur-sm p-4 rounded-lg border border-slate-200 shadow-sm">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-slate-700">
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                  <span>Resumo Flash em minutos</span>
                </div>
                <div className="hidden sm:block w-px h-4 bg-slate-300"></div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                  <span>PDF em 24–48h úteis</span>
                </div>
                <div className="hidden sm:block w-px h-4 bg-slate-300"></div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                  <span>Checklist de riscos</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="space-y-6">
            {/* Métricas do Beta */}
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-xl shadow-md border border-slate-100 text-center">
                <div className="bg-blue-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <Clock className="h-5 w-5 text-blue-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Tempo do Resumo Flash</div>
                <div className="text-xs text-slate-600">Em horas (SLA: até 8h úteis)</div>
              </div>
              
              <div className="bg-white p-4 rounded-xl shadow-md border border-slate-100 text-center">
                <div className="bg-blue-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <FileText className="h-5 w-5 text-blue-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Prazo do Laudo (PDF)</div>
                <div className="text-xs text-slate-600">24–48h úteis (checklist + cenários)</div>
              </div>
              
              <div className="bg-white p-4 rounded-xl shadow-md border border-slate-100 text-center">
                <div className="bg-blue-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <Users className="h-5 w-5 text-blue-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Fila priorizada p/ CBs</div>
                <div className="text-xs text-slate-600">Atendimento por ordem de chegada</div>
              </div>
            </div>

            {/* Bullets diretas para CB */}
            <div className="bg-white p-6 rounded-xl shadow-lg border border-slate-100">
              <h3 className="font-semibold text-lg mb-4 text-slate-900">
                Para Correspondentes Bancários
              </h3>
              <div className="grid grid-cols-1 gap-4">
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 w-8 h-8 rounded-full flex items-center justify-center">
                    <Clock className="h-4 w-4 text-blue-600" />
                  </div>
                  <span className="text-slate-700">Economize horas lendo edital/matrícula</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 w-8 h-8 rounded-full flex items-center justify-center">
                    <Shield className="h-4 w-4 text-blue-600" />
                  </div>
                  <span className="text-slate-700">Checklist de riscos pronto (ônus, ocupação, dívidas)</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 w-8 h-8 rounded-full flex items-center justify-center">
                    <TrendingUp className="h-4 w-4 text-blue-600" />
                  </div>
                  <span className="text-slate-700">Viabilidade clara (flip/locação/financiamento)</span>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 w-8 h-8 rounded-full flex items-center justify-center">
                    <MessageCircle className="h-4 w-4 text-blue-600" />
                  </div>
                  <span className="text-slate-700">Suporte via WhatsApp</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;